var _style, _path, _rect, _rect2, _rect3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTHotelbeds(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "layer",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 652 652",
    style: {
      enableBackground: "new 0 0 652 652"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#193153;}\n\t.st1{fill:#B92354;}\n\t.st2{fill:#A1CFCA;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M111.7,333.5v34.4H90.7v-30.9c0-8.6-3.8-12.3-9.9-12.3c-6.8,0-12,4.2-12,14.2v29H47.8v-83.2h21.1v28.7 c4.7-4.3,11-6.5,18.1-6.5C101,306.8,111.7,314.9,111.7,333.5 M164.1,336.7c0,9.2-5.4,14.4-12.6,14.4c-7.1,0-12.6-5.2-12.6-14.4 c0-9.1,5.5-14.2,12.6-14.2C158.7,322.5,164.1,327.6,164.1,336.7 M117.6,336.7c0,18.2,14.3,31.1,33.9,31.1c19.8,0,33.9-13,33.9-31.1 c0-18.1-14.1-30.9-33.9-30.9C131.8,305.8,117.6,318.6,117.6,336.7 M255.5,333.8c0.7-8.5,5.5-13.1,12.7-13.1c5.9,0,10.2,3.3,11.6,8.3 L255.5,333.8 M284.6,346.5c-4.1,3.5-8,5.2-13.9,5.2c-6.6,0-11.3-2.3-13.6-7.2l42.9-8.2c-0.1-19.6-14.6-30.6-31.9-30.6 c-19.1,0-33.2,12.9-33.2,30.9c0,18,13.9,31.1,35.2,31.1c11.4,0,19.8-3.3,25.5-9.7L284.6,346.5 M395.7,336.7 c0,9.2-5.5,14.4-12.6,14.4c-7.1,0-12.6-5.2-12.6-14.4c0-9.1,5.5-14.2,12.6-14.2C390.1,322.5,395.7,327.6,395.7,336.7 M416.9,336.7 c0-19.1-13.2-30.9-29.5-30.9c-7,0-12.6,2-16.7,6.2v-27.4h-21.1v82.2h20.1v-6c4,4.8,9.9,7,17.7,7 C403.7,367.8,416.9,355.9,416.9,336.7 M443.5,333.8c0.7-8.5,5.5-13.1,12.7-13.1c5.9,0,10.2,3.3,11.6,8.3L443.5,333.8 M472.7,346.5 c-4.1,3.5-8,5.2-13.9,5.2c-6.6,0-11.3-2.3-13.6-7.2l42.9-8.2c-0.1-19.6-14.6-30.6-31.9-30.6c-19.1,0-33.2,12.9-33.2,30.9 c0,18,13.9,31.1,35.2,31.1c11.4,0,19.8-3.3,25.5-9.7L472.7,346.5 M540.9,336.7c0,9.2-5.4,14.4-12.5,14.4c-7.2,0-12.6-5.2-12.6-14.4 c0-9.1,5.4-14.2,12.6-14.2C535.5,322.5,540.9,327.6,540.9,336.7 M540.6,284.6V312c-4-4.2-9.6-6.2-16.6-6.2 c-16.4,0-29.6,11.9-29.6,30.9c0,19.2,13.2,31.1,29.6,31.1c7.8,0,13.6-2.2,17.6-7v6h20.1v-82.2H540.6z M570.4,361.6 c5.9,3.7,16.4,6.2,26.6,6.2c19.5,0,29.7-8.6,29.7-19.7c0-23.8-35.4-14.9-35.4-23.2c0-2.2,2.6-4.2,9.6-4.2c5.3,0,11.3,1.1,17.3,4.4 l6.3-14.3c-6-3.3-15.3-5.1-23.7-5.1c-18.8,0-29.3,8.6-29.3,19.9c0,24,35.5,14.9,35.5,22.9c0,2.5-2.3,4.1-9.4,4.1 c-7.3,0-15.4-2.1-20.9-5.5L570.4,361.6 M227.1,349.7c-1.8,1.2-4.1,1.9-6.4,1.9c-3.8,0-6.2-2.4-6.2-6.9v-23.2h13.6v-15.7h-13.6v-15.2 v-5.9h-21.1v5.9v14.8v39.5c0,15.4,8.9,22.9,24.3,22.9c5.5,0,11-1.1,14.6-3.4L227.1,349.7z M308.7,346c0,14.2,8.8,21.8,23.1,21.8 c3.3,0,6.4-0.4,9.7-1.5l-0.9-15.7c-1.1,0.6-3,1.1-4.7,1.1c-4.1,0-6.5-2.3-6.5-6.8v-60.3h-20.8V346"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 47.8,
    y: 346.8,
    className: "st1",
    width: 21.1,
    height: 21.1
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 47.8,
    y: 325.7,
    className: "st0",
    width: 21.1,
    height: 21.1
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 26.7,
    y: 325.7,
    className: "st2",
    width: 21.1,
    height: 21.1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTHotelbeds);
export default __webpack_public_path__ + "static/media/T-hotelbeds.d9cc4a74a9d5efbbcd8ee5c6f68872db.svg";
export { ForwardRef as ReactComponent };